module.exports = __webpack_public_path__ + "assets/3a5e388e938cbbbbb4acb90b5cfc2d73.woff";


//////////////////
// WEBPACK FOOTER
// ./~/@blueprintjs/core/resources/icons/icons-20.woff
// module id = 3634
// module chunks = 0